import { render, staticRenderFns } from "./StockVariance.vue?vue&type=template&id=6de98ffc"
import script from "./StockVariance.vue?vue&type=script&lang=js"
export * from "./StockVariance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports